import { render } from "./afterHomework.vue?vue&type=template&id=7b63b123&scoped=true"
import script from "./afterHomework.vue?vue&type=script&lang=js"
export * from "./afterHomework.vue?vue&type=script&lang=js"

import "./afterHomework.vue?vue&type=style&index=0&id=7b63b123&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b63b123"]])

export default __exports__